import { Container, Segment } from 'semantic-ui-react';

import { useIntl, defineMessages } from 'react-intl';
//import { useSelector, shallowEqual } from 'react-redux';

import {
  //Anontools,
  LanguageSelector,
  Logo,
} from '@plone/volto/components';

import { HeaderSearch } from '@redturtle/volto-io-studio/components/Layout';

const messages = defineMessages({
  header_complementary_options: {
    id: 'Complementary options',
    defaultMessage: 'Opzioni complementari',
  },
  language_selector: {
    id: 'Language selector',
    defaultMessage: 'Selettori per la lingua del sito',
  },
});

const HeaderBanner = ({ pathname }) => {
  const intl = useIntl();

  return (
    <Segment basic className="header-banner-wrapper">
      <Container>
        <div className="header-banner">
          <Logo />

          {/* <div className="tools">
              <Anontools />
            </div> */}
          <div
            className="header-right"
            role="group"
            aria-label={intl.formatMessage(
              messages.header_complementary_options,
            )}
          >
            <HeaderSearch />

            <div
              role="region"
              aria-label={intl.formatMessage(messages.language_selector)}
            >
              <LanguageSelector />
            </div>
          </div>
        </div>
      </Container>
    </Segment>
  );
};

export default HeaderBanner;
